import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    console.log("Dropdown controller connected successfully")
    // Ensure menu is hidden on connect
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
      console.log("Menu hidden on connect")
    }
    this.boundHandleOutsideClick = this.handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleOutsideClick)
  }

  toggle(event) {
    console.log("Toggle clicked!")
    event.stopPropagation()
    
    if (this.hasMenuTarget) {
      if (this.menuTarget.classList.contains("hidden")) {
        this.open()
      } else {
        this.close()
      }
    }
  }

  open() {
    console.log("Opening dropdown")
    this.menuTarget.classList.remove("hidden")
    document.addEventListener("click", this.boundHandleOutsideClick)
  }

  close() {
    console.log("Closing dropdown")
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.boundHandleOutsideClick)
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}